
<template>
  <div id="page_settings" class="column p0">
    <div class="column combo_1" style="margin-bottom: 4rem">
      <div class="columns column">
        <div class="title_settings">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
          <h1>{{ $t("msg.settings.title") }}</h1>
        </div>
      </div>

      <nav class="tabs_settings">
        <span
          class="tabs_item"
          :class="active == index && 'tabs_item_active'"
          v-for="(item, index) in items"
          :key="index"
          @click="active = index"
        >
          {{ item }}
        </span>
      </nav>

      <div v-if="active == 0" class="tab_content">
        <div class="tab_content_left">
          <h2>{{ $t("msg.settings.profile") }}</h2>
          <p>{{ $t("msg.settings.updateInfoProfile") }}</p>

          <div style="display: flex; margin-top: 20px">
            <p class="fat mr_5">{{ $t("msg.email") }}:</p>
            {{ member.email }}
          </div>
          <div style="display: flex">
            <p class="fat mr_5">{{ $t("msg.phone") }}:</p>
            +{{ member.phone }}
          </div>
          <div style="color: #6b7280; display: flex; align-items: center">
            <p class="fat mr_5">{{ $t("msg.settings.profileStatus") }}</p>
            <div
              class="icon_class_1"
              v-html="iconSets.shield_true"
              v-if="member.phone && member.email"
            ></div>
            <div
              class="icon_class_1"
              v-html="iconSets.shield_false"
              v-else
            ></div>
          </div>
        </div>
        <div class="tab_content_right">
          <div class="combo_1">
            <label>{{ $t("msg.country_residency") }}</label>
            <VuePhoneNumberInput
              class="VuePhoneNumberInput"
              v-model="signupform.phone"
              :border-radius="6"
              :translations="{
                countrySelectorLabel: $t('msg.phone_code'),
                phoneNumberLabel: $t('msg.phone_optional'),
              }"
              color="#333364"
              valid-color="#342365"
              @update="verifyCountry($event)"
              @keyup="onChangeRemoveError(signupform, 'phone')"
              :no-example="countriesNotAllowed"
              :error="countriesNotAllowed"
            />

            <!-- <VuePhoneNumberInput
              class="VuePhoneNumberInput"
              v-model="signupform.phone"
              :border-radius="6"
              :translations="{
                countrySelectorLabel: $t('msg.phone_code'),
                phoneNumberLabel: $t('msg.phone_optional'),
              }"
              color="#333364"
              valid-color="#342365"
              @update="verifyCountry($event)"
              @keyup="onChangeRemoveError(signupform, 'phone')"
              :error="countriesNotAllowed"
              :no-example="countriesNotAllowed"
            /> -->

            <!-- <VuePhoneNumberInput  class="VuePhoneNumberInput" v-model="phone" @update="verifyCountry($event)"/> -->

            <span
              class="help is-danger"
              v-show="hasError.phone && !countriesNotAllowed"
              >{{ $t(`msg.phone_already_registered`) }}</span
            >

            <span class="help is-danger" v-show="countriesNotAllowed">{{
              $t("msg.invalid_phone_country")
            }}</span>
          </div>

          <div class="combo_1">
            <div style="display: flex; align-items: center">
              <label>{{ $t("msg.email") }}</label>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="tooltip_disclaimer_new"
                @mouseover="showInfo['1a'] = true"
                @mouseleave="showInfo['1a'] = false"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>

            <input
              class="input_write_form"
              type="text"
              id="email"
              :style="errorInputStyle.email"
              placeholder="Email*"
              @keyup="onChangeRemoveError(signupform, 'email')"
              v-model="signupform.email"
            />

            <span class="help is-danger" v-show="hasError.email">
              {{ $t(`msg.email_already_registered`) }}</span
            >

            <transition name="bounce">
              <div
                v-if="showInfo['1a']"
                class="info"
                v-html="$t('msg.create_new_email_recommendation')"
              />
            </transition>
          </div>
        </div>
      </div>

      <div v-if="active == 1" class="tab_content">
        <div class="tab_content_left">
          <h2>{{ $t("msg.settings.security") }}</h2>
          <p>{{ $t("msg.settings.updateInfoSecurity") }}</p>
        </div>
        <div class="tab_content_right">
          <div class="combo_1">
            <label>{{ $t("msg.current_password") }}</label>
            <input
              :placeholder="$t('msg.current_password') + '*'"
              class="input_write_form"
              type="password"
              v-model="passwordOld"
            />
          </div>

          <div class="combo_1">
            <div style="display: flex; align-items: center">
              <label>{{ $t("msg.new_password") }}</label>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="tooltip_disclaimer_new"
                @mouseover="showInfo['1b'] = true"
                @mouseleave="showInfo['1b'] = false"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>

            <input
              class="input_write_form"
              type="password"
              :style="errorInputStyle.password"
              :placeholder="$t('msg.password_create') + '*'"
              v-model="password"
              @keyup="onChangeRemoveError(signupform, 'newPassword')"
            />

            <transition name="bounce">
              <div
                class="info"
                v-if="showInfo['1b']"
                v-html="$t(`msg.password_requirements`, 1)"
              />
            </transition>
          </div>

          <div class="combo_1">
            <label>{{ $t("msg.confirm_password") }}</label>
            <input
              class="input_write_form"
              type="password"
              :style="errorInputStyle.passwordConfirmation"
              :placeholder="$t('msg.confirm_password') + '*'"
              v-model="passwordConfirmation"
              @keyup="onChangeRemoveError(signupform, 'passwordConfirmation')"
            />

            <div
              class="info"
              v-if="showInfo['1c']"
              v-html="$t(`msg.confirm_password_error`, 1)"
            />
          </div>
        </div>
      </div>

      <div v-if="active == 2" class="tab_content">
        <div class="tab_content_left">
          <h2>{{ $t("msg.settings.notifications") }}</h2>
          <p>{{ $t("msg.settings.updateInfoNotifications") }}</p>
        </div>
        <div class="tab_content_right">
          <div class="combo_1">
            <label>{{ $t("msg.settings.toggleEmail") }}</label>
            <div class="action">
              <input
                type="checkbox"
                :checked="notify"
                name="toggle"
                id="toggle"
              />
              <label for="toggle"></label>
            </div>
          </div>
        </div>
      </div>

      <div v-if="active == 0" class="tab_content_bottom">
        <p>{{ $t("msg.settings.updateProfile") }}</p>
        <button @click="() => callChangeInfo()">
          {{ $t("msg.save") }}
        </button>
      </div>

      <div v-if="active == 1" class="tab_content_bottom">
        <p>{{ $t("msg.settings.updateSecurity") }}</p>
        <button @click="() => callChangePass()">
          {{ $t("msg.save") }}
        </button>
      </div>

      <div v-if="active == 2" class="tab_content_bottom">
        <p>{{ $t("msg.settings.updateNotification") }}</p>
        <button @click="() => callChangeNotify()">
          {{ $t("msg.save") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

function SignupFields() {
  this.phone = "";
  this.email = "";
  this.currentPassword = "";
  this.newPassword = "";
  this.confirmPassword = "";
  this.isNotChinaCitizen = true;
  this.isNotUsaCitizen = true;
  // this.formSent = "";
}

export default {
  created() {
    this.setValues();
  },
  mounted() {
    this.setValidationFields(SignupFields);
    this.initTitleItems();
    this.signupform.email = this.member.email;
    this.signupform.phone = this.member.phone;
  },
  data: () => ({
    // selectedSettings: "security",
    // selectedSubject: "password",
    notify: "",
    passwordOld: "",

    password: "",
    passwordConfirmation: "",

    phoneFormat: "",
    validPhone: true,

    countriesNotAllowed: false,
    signupform: new SignupFields(),

    showInfo: {
      "1a": false,
      "1b": false,
      "1c": false,
    },
    active: 0,
    items: [],
  }),
  components: {
    // SettingsPreferences,
    // SettingsSecurity,
    VuePhoneNumberInput,
  },
  methods: {
    initTitleItems() {
      this.items = [
        this.$t("msg.settings.profile"),
        this.$t("msg.settings.security"),
        this.$t("msg.settings.notifications"),
      ];
    },

    verifyCountry($event) {
      console.log($event);

      this.results = $event.countryCode;
      this.phoneFormat = $event.formattedNumber;
      this.validPhone = $event.isValid;

      if (
        this.results == "CN" ||
        this.results == "HK" ||
        this.results == "US"
      ) {
        this.countriesNotAllowed = true;
      } else {
        this.countriesNotAllowed = false;
      }
    },

    setValues() {
      if (this.member.notify) {
        this.notify = true;
      } else {
        this.notify = false;
      }
    },

    callChangeInfo() {
      let email = this.signupform.email;
      let phone = this.phoneFormat;
      let valid = this.validPhone;

      if (phone && !valid) {
        Swal.fire({
          icon: "error",
          title: this.$t("msg.error"),
          text: this.$t("msg.invalid_phone"),
        });
        return;
      }

      let payload = {
        newEmail: email,
        newPhone: phone && phone.replace("+", ""),
        password: "",
      };

      Swal.fire({
        title: this.$t("msg.password"),
        input: "password",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Submit",
        showLoaderOnConfirm: true,
        preConfirm: (login) => {
          payload.password = login;
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.$store
            .dispatch("putChangeInfo", payload)
            .then((r) => {
              if (r.status == 200) {
                Swal.fire({
                  icon: "success",
                  title: this.$t("msg.status_done"),
                  text: this.$t("msg.settings.popupChangesApply"),
                });
              }
            })
            .catch((e) => {
              console.log(e.message);
              Swal.fire({
                icon: "error",
                title: this.$t("msg.error"),
                text: e.message,
              });
            });
        }
      });
    },

    callChangePass() {
      const form = this.signupform;
      let validatePassword = this.validatePassword(this.password);

      this.showOrHideError("password", validatePassword);
      this.showOrHideError(
        "passwordConfirmation",
        form.passwordConfirmation && form.passwordConfirmation === form.password
      );

      let payload = {
        password: this.password,
        passwordConfirmation: this.passwordConfirmation,
        passwordOld: this.passwordOld,
      };

      if (validatePassword && !this.passwordConfirmation) {
        this.showInfo["1c"] = true;
        this.showInfo["1b"] = false;
      }
      
      if (!validatePassword) {
        this.showInfo["1b"] = true;
      }

      if (validatePassword && this.passwordConfirmation) {
        Swal.fire({
          title: this.$t("msg.settings.popupSure"),
          text: this.$t("msg.confirm_password_error"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("msg.yes"),
          cancelButtonText: this.$t("msg.cancel"),
        }).then(async (result) => {
          if (result.isConfirmed) {
            await this.$store
              .dispatch("putChangePassword", payload)
              .then((r) => {
                console.log(r);
                Swal.fire(
                  this.$t("msg.status_done"),
                  this.$t("msg.settings.popupChangesApply"),
                  "success"
                );
              })
              .catch((e) => {
                Swal.fire({
                  icon: "error",
                  title: this.$t("msg.error"),
                  text: this.$t("msg.wrong_password_confirmation"),
                });

                console.log(e);
              });
          }
        });
      }
    },

    async callChangeNotify() {
      if (!this.notify) {
        await this.$store
          .dispatch("putChangeNotifyOn")
          .then((r) => {
            Swal.fire(
              this.$t("msg.status_done"),
              this.$t("msg.settings.popupChangesApply"),
              "success"
            );
            console.log(r);
          })
          .catch((e) => {
            Swal.fire({
              icon: "error",
              title: this.$t("msg.error"),
              text: this.$t("msg.redeem_deleted_error"),
            });
            console.log(e);
          });
      }

      if (this.notify) {
        await this.$store
          .dispatch("putChangeNotifyOff")
          .then((r) => {
            Swal.fire(
              this.$t("msg.status_done"),
              this.$t("msg.settings.popupChangesApply"),
              "success"
            );
            console.log(r);
          })
          .catch((e) => {
            Swal.fire({
              icon: "error",
              title: this.$t("msg.error"),
              text: this.$t("msg.redeem_deleted_error"),
            });
            console.log(e);
          });
      }
    },
  },
  computed: {
    ...mapGetters(["member"]),
  },
  watch: {
    "$i18n.locale": function () {
      this.initTitleItems();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/private/Settings.vue